export default "__VITE_ASSET__CFlxc3zd__"